<template>
  <!-- eslint-disable-next-line vue/no-unused-refs -->
  <el-form ref="form" v-bind="formProps" v-on="formEvents" :model="model" :rules="rules">
    <QS-column-box ref="TextBLMColumnBox" :column="column" style="align-items: flex-start;">
      <form-text-generator
        v-for="(item, index) of dataList"
        :item="item"
        :model="model"
        :ref="item.itemConfig && item.itemConfig.prop"
        :key="item.itemConfig && index + item.itemConfig.prop"
      />
    </QS-column-box>
  </el-form>
</template>
<script>
import mixin from './mixins'

export default {
  name: 'FormTextBox',
  props: {
    column: {
      type: Number,
      default: 3,
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: Object,
      default: () => ({}),
    },
    formProps: {
      type: Object,
      default: () => ({}),
    },
    formEvents: {
      type: Object,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/no-unused-properties
    separator: {
      type: [Boolean, String],
      default: ':',
    },
  },
  watch: {
    dataList: {
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          if (newVal.length !== oldVal.length) {
            this.autoColumn()
          }
        }
      },
    },
    model: {
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          if (newVal.length !== oldVal.length) {
            this.autoColumn()
          }
        }
      },
    },
  },
  methods: {
    autoColumn() {
      this.$nextTick(() => {
        this.$refs.TextBLMColumnBox?.calcWidth()
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    clearValidate() {
      this.$refs.form.clearValidate()
    },
  },
  mixins: [mixin],
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
